function initSlider(container) {

  if (container.dataset.sliderInit === "true") return;
  container.dataset.sliderInit = "true";

  const wrapper = container.querySelector('.slider-wrapper');
  const slides = wrapper.querySelectorAll('.slider-slide');
  const prevBtn = container.querySelector('.slider-btn.prev');
  const nextBtn = container.querySelector('.slider-btn.next');

  const columnsDesktop = parseFloat(container.dataset.columnsDesktop);
  const columnsTablet  = parseFloat(container.dataset.columnsTablet);
  const columnsMobile  = parseFloat(container.dataset.columnsMobile);

  function getSlidesPerView() {
    const w = window.innerWidth;
    if (w >= 1024) return columnsDesktop;
    if (w >= 768)  return columnsTablet;
    return columnsMobile;
  }

  let slidesPerView = getSlidesPerView();

  function updateSlideWidths() {
    const slideWidth = wrapper.clientWidth / slidesPerView;
    slides.forEach(slide => {
      slide.style.minWidth = slideWidth + "px";
    });
  }

  function slideBy(amount) {
    wrapper.scrollTo({
      left: amount,
      behavior: 'smooth'
    });
  }

  function slideNext() {
    const slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(wrapper).gap);
    const maxLeft = wrapper.scrollWidth - wrapper.clientWidth;
    slideBy(Math.min(wrapper.scrollLeft + slideWidth, maxLeft));
  }

  function slidePrev() {
    const slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(wrapper).gap);
    slideBy(Math.max(wrapper.scrollLeft - slideWidth, 0));
  }

  function updateButtons() {
    const canScroll = wrapper.scrollWidth > wrapper.clientWidth;
    prevBtn.style.display = canScroll ? "block" : "none";
    nextBtn.style.display = canScroll ? "block" : "none";
  }

  nextBtn.addEventListener('click', slideNext);
  prevBtn.addEventListener('click', slidePrev);

  window.addEventListener('resize', () => {
    slidesPerView = getSlidesPerView();
    updateSlideWidths();
    updateButtons();
  });

  requestAnimationFrame(() => {
    updateSlideWidths();
    updateButtons();
  });

  wrapper.addEventListener('scroll', updateButtons);
}

const observer = new MutationObserver(mutations => {
  mutations.forEach(m => {
    m.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.matches?.('.slider-target')) {
        initSlider(node);
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });
